let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("l4eYp")).then(() => parcelRequire('f8nDI'));